// Mantiene la pantalla encendida mientras se comprime o se sube (Screen Wake Lock), para que el
// navegador no suspenda el trabajo. Si la API no existe o se rechaza, se continúa sin ella.
let sentinel: WakeLockSentinel | null = null;
let holders = 0;

export async function requestWakeLock(): Promise<void> {
  holders += 1;
  if (sentinel || typeof navigator === 'undefined' || !('wakeLock' in navigator)) return;
  try {
    sentinel = await navigator.wakeLock.request('screen');
    sentinel.addEventListener('release', () => {
      sentinel = null;
    });
  } catch {
    sentinel = null;
  }
}

export function releaseWakeLock(): void {
  holders = Math.max(0, holders - 1);
  if (holders === 0 && sentinel) {
    void sentinel.release().catch(() => undefined);
    sentinel = null;
  }
}
